import { useQuery } from "@tanstack/react-query";

import { matchQueryOptions } from "./matchQueryOptions";

// Матч для шапки экрана разбора и id его разбора.
export const useMatch = (matchId: number) => useQuery(matchQueryOptions(matchId));
